import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { Spin, Row, Col, Input, Button, Table, Modal, Form, message, Layout, Select, InputNumber, Radio, DatePicker, Icon,Switch } from 'antd'
import { discountList, discountCreate, discountDetail, merchantList, getGoodLists } from '_src/api/api'

import './style/discount.less'

const { TextArea } = Input
const { RangePicker } = DatePicker
const { Search } = Input
const { Option } = Select
const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
}

class Discount extends PureComponent {
  constructor() {
    super()
    this.state = {
      isLoading: false,

      modelVisible: false,
      lookModelVisible: false,

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0,
        current: 1,
      },

      list: [],
      goodsList: [],
      merchant: [],
      columns: [
        {
          title: <span>编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>优惠劵名称</span>,
          dataIndex: 'name',
        },
        {
          title: <span>优惠劵类型</span>,
          render: item => <div>{item.type === 0 ? '满减券' : '折扣券'}</div>,
        },
        {
          title: <span>使用门槛</span>,
          render: item => <div>{item.useType === 1 ? (item.useTypeVal / 100).toFixed(2) : '无门槛'}</div>,
        },
        {
          title: <span>面值</span>,
          render: item => <div>{item.type === 1 ? item.disCount * 10 + '折' : (item.disCount / 100).toFixed(2) + '元'}</div>,
        },
        {
          title: <span>适用商家</span>,
          dataIndex: 'platformType',
          render: item => <div>{item === 0 ? '全平台' : '部分商户'}</div>,
        },
        {
          title: <span>有效期</span>,
          render: item => <div>{item.timeType === 0 ? `领取后${item.days}天有效` : `${item.startAt} 至 ${item.endAt}`}</div>,
        },
        {
          title: <span>状态</span>,
          render: item => <div>{item.timeType === 0 || (item.timeType === 1 && item.endAt > item.startAt) ? <div className="flex-h-a" style={{ color: '#40a9ff' }}><Icon type="check-circle" theme="twoTone" style={{ fontSize: 20, marginRight: 10 }} /> 使用中</div> : '已过期'}</div>,
        },
        {
          title: <span>备注</span>,
          dataIndex: 'desc',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <div>
            <Button icon="eye" id={item.id} onClick={() => { this.lookDetail(item.id) }} style={{ marginRight: '10px' }}>详情</Button>
          </div>,
        },
      ],
      platformType: 0
    }
  }

  componentDidMount() {
    const { params } = this.state
    this.loadList(params)
    merchantList({ pageSize: -1 })
      .then(res => {
        this.setState({
          merchant: res.data,
        })
      })
  }

  loadList(params) {
    this.setState({ isLoading: true })
    discountList(params)
      .then(res => {
        const list = res.data.content
        list.forEach(item => {
          item.startAt = moment(item.startAt).format('YYYY-MM-DD')
          const endAt = new Date(item.endAt)
          endAt.setDate(endAt.getDate() - 1)
          item.endAt = moment(endAt).format('YYYY-MM-DD')
        })
        this.setState({
          list,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 优惠券搜索
  onSearch = (e) => {
    const { params } = this.state
    params.pageNum = 0
    if (e) {
      params.name = e
    } else {
      delete params.name
    }
    this.loadList(params)
  }

  // 创建优惠券弹窗
  create = (e) => {
    this.setState({ createModelVisible: true })
  }
  // 关闭创建
  handleCancel = (e) => {
    this.setState({
      createModelVisible: false,
      lookModelVisible: false,
    })
  }

  getGoodsList = (e) => {
    if (this.state.haveMerchant && e === 2) {
      let str = '?pageSize=-1&'
      this.state.haveMerchant.map((v, k) => {
        str += 'merchantIds=' + v + '&'
      })
      str = str.substring(0, str.length - 1)
      getGoodLists(str).then(res => {
        if (res.data) {
          let temdata = []
          res.data.map((v, k) => {
            if (v.merchantGoods.length > 0) {
              temdata = temdata.concat(v.merchantGoods)
            }
          })
          this.setState({ goodsList: temdata })
        }
      })
    }

    if (this.state.platformType === 0 && e === 2) {
      getGoodLists('?pageSize=-1').then(res => {
        if (res.data) {
          let temdata = []
          res.data.map((v, k) => {
            if (v.merchantGoods.length > 0) {
              temdata = temdata.concat(v.merchantGoods)
            }
          })
          this.setState({ goodsList: temdata })
        }
      })
    }

  }

  // 提交创建优惠券
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const hide = message.loading('保存中...', 0)
        let { type, haveMerchant, timeType, days, useType, useTypeVal, timerArr, useClassify, classifyVal } = this.state
        values.type = type
        values.timeType = timeType
        values.platformType = Number(values.platformType)
        values.useType = Number(useType)
        values.useClassify = Number(useClassify)

        // 优惠券平台为部分商家.拿商户列表
        if (values.platformType === 1) {
          if (haveMerchant && haveMerchant.length) {
            haveMerchant.forEach(item => item = Number(item))
            values.platformVal = haveMerchant
          } else {
            message.error('优惠券未选择使用商户')
          }
        } else {
          values.platformVal = []
        }
        // 部分商品商家.拿商户列表
        if (values.useClassify === 2) {
          if (classifyVal && classifyVal.length) {
            classifyVal.forEach(item => item = Number(item))
            values.classifyVal = classifyVal
          } else {
            message.error('优惠券未选择商品')
          }
        } else {
          values.classifyVal = []
        }
        // 时间类型选择用户领取后计时
        if (values.timeType === 0) {
          if (days) {
            values.days = days
          } else {
            message.error('请输入优惠券有效时间')
            return
          }
          // 时间区间
        } else if (values.timeType === 1) {
          if (timerArr && timerArr.length) {
            values.startAt = moment(timerArr[0]).format('YYYY-MM-DD 00:00:00')
            const endAt = new Date(moment(timerArr[1]))
            values.endAt = moment(endAt).format('YYYY-MM-DD 23:59:59')
          } else {
            message.error('请选择优惠券有效时间')
          }
        }

        // 使用门槛
        if (values.useType === 1) {
          if (useTypeVal) {
            values.useTypeVal = Number(useTypeVal) * 100
          } else {
            message.error('请输入使用门槛')
          }
        }

        // 类型为满减
        if (values.type === 0) {
          values.disCount = Number(values.amount) * 100
          // 类型为折扣
        } else if (values.type === 1) {
          values.disCount = Number(values.disCount) / 10
        }
        discountCreate(values).then(res => {
          hide()
          message.success('保存成功', 1.5, () => {
            const { pageSize } = this.state.params
            const params = {
              pageNum: 0,
              pageSize,
            }
            this.setState({
              createModelVisible: false,
              isLoading: true,
              params,
            })
            this.loadList(params)
          })
        })
      }
    })
  }

  // 创建元素
  createModal = () => {
    const { type, timeType, merchant, goodsList } = this.state
    const { getFieldDecorator, setFieldsValue } = this.props.form
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    }
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form">
        <Form.Item label="优惠券名称：" className='flex'>
          {getFieldDecorator('name', {
            rules: [{
              required: true,
              message: '请输入优惠券名称',
            }],
          })(
            <Input placeholder="请输入优惠券名称" />
          )}
        </Form.Item>
        <Form.Item label="优惠券类型：" className='flex'>
          {getFieldDecorator('type', {
            rules: [{
              required: true,
              message: '请选择优惠券类型',
            }],
          })(
            <Radio.Group
              onChange={(e) => {
                this.setState({ type: e.target.value })
              }}
            >
              <Radio style={radioStyle} value={0}>满减券</Radio>
              <Radio style={radioStyle} value={1}>折扣券</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        {
          type === 1
            ? <Form.Item label="折扣：" className='flex'>
              {getFieldDecorator('disCount', {
                rules: [{
                  required: true,
                  message: '请输入消费折扣0~10',
                }],
              })(
                <span><InputNumber placeholder="消费折扣，1~10折" style={{ width: 178 }} min={1} max={10} />（1~10的折扣）</span>
              )}
            </Form.Item>
            : <Form.Item label="面额：" className='flex'>
              {getFieldDecorator('amount', {
                rules: [{
                  required: true,
                  message: '请输入优惠券面额',
                }],
              })(
                <InputNumber placeholder="优惠券面额" style={{ width: 178 }} min={0} />
              )}
            </Form.Item>
        }
        <Form.Item label="使用门槛：" className='flex'>
          {getFieldDecorator('useType', {
            rules: [{
              required: true,
              message: '请选择使用门槛类型',
            }],
          })(
            <Radio.Group
              onChange={(e) => {
                this.setState({
                  useType: e.target.value,
                })
              }}
            >
              <Radio style={radioStyle} value={0}>无限制</Radio>
              <Radio style={radioStyle} value={1}>消费满<InputNumber onChange={(e) => { this.setState({ useTypeVal: e }) }} style={{ width: 100, marginLeft: 10, marginRight: 10 }} min={0} /> 元可用</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="总发行量：" className='flex'>
          {getFieldDecorator('total', {
            rules: [{
              required: true,
              message: '请输入总发行量',
            }],
          })(
            <InputNumber placeholder="请输入总发行量" style={{ width: 178 }} />
          )}
        </Form.Item>
        <Form.Item label="每人限领：" className='flex'>
          {getFieldDecorator('limit', {
            rules: [{
              required: true,
              message: '请输入每人限制领取次数',
            }],
          })(
            <InputNumber placeholder="每人限制领取次数" style={{ width: 178 }} />
          )}
        </Form.Item>
        <Form.Item label="适用商户：" className='flex'>
          {getFieldDecorator('platformType', {
            rules: [{
              required: true,
              message: '请选择优惠券类型',
            }],
            initialValue: 0
          })(
            <Radio.Group
              style={{ width: 250 }}
              onChange={(e) => {
                this.setState({
                  platformType: e.target.value,
                  classifyVal: [],
                  goodsList: [],
                  useClassify: 1
                })
                setFieldsValue({
                  useClassify: 1
                });
              }}
            >
              <Radio style={radioStyle} value={0}>全平台</Radio>
              <Radio style={radioStyle} value={1}>
                <span>部分商家</span>
                {this.state.platformType === 1
                  ? <div>
                    <Select
                      mode="tags"
                      size={'default'}
                      placeholder="输入商家id搜索"
                      mode="multiple"
                      onChange={(e) => {
                        this.setState({ haveMerchant: e, classifyVal: [], useClassify: 1, goodsList: [] })
                        setFieldsValue({
                          useClassify: 1
                        });
                      }}
                      style={{ width: '100%' }}
                    >
                      {
                        merchant.map(item => (
                          <Option key={item.id} value={String(item.id)}>{item.merchantName}</Option>
                        ))
                      }
                    </Select>
                  </div>
                  : null
                }
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="使用范围：" className='flex'>
          {getFieldDecorator('useClassify', {
            rules: [{
              required: true,
              message: '请选择范围',
            }],
          })(
            <Radio.Group
              style={{ width: 250 }}
              onChange={(e) => {
                this.setState({ useClassify: e.target.value })
                this.getGoodsList(e.target.value)
              }}
            >
              <Radio style={radioStyle} value={1}>全场通用</Radio>
              <Radio style={radioStyle} value={2}>
                <span>部分商品</span>
                {this.state.useClassify === 2
                  ? <div>
                    <Select
                      mode="tags"
                      size={'default'}
                      mode="multiple"
                      placeholder="请选择部分商品"
                      onChange={(e) => {
                        this.setState({ classifyVal: e })
                      }}
                      style={{ width: '100%' }}
                    >
                      {
                        goodsList.map(item => (
                          <Option key={item.id} value={String(item.id)}>{item.goodsName}</Option>
                        ))
                      }
                    </Select>
                  </div>
                  : null
                }
              </Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="有效期：" className='flex'>
          {getFieldDecorator('timeType', {
            rules: [{
              required: true,
              message: '请选择有效日期类型',
            }],
          })(
            <Radio.Group
              onChange={(e) => {
                this.setState({
                  timeType: e.target.value,
                })
              }}
            >
              <Radio style={radioStyle} value={0}>固定天数{timeType === 0 ? <span>，用户领取 <InputNumber onChange={(e) => { this.setState({ days: e }) }} style={{ width: 100, marginLeft: 10, marginRight: 10 }} min={0} /> 天后到期</span> : null}</Radio>
              <Radio style={radioStyle} value={1}>日期范围{timeType === 1 ? <RangePicker style={{ width: 270, marginLeft: 10 }} onChange={(e) => { console.log(e); this.setState({ timerArr: e }) }} /> : null}</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="是否隐藏：" className='flex'>
          {getFieldDecorator('hide', {
            valuePropName: 'checked',
            initialValue: true
          })(
            <Switch checkedChildren="隐藏" unCheckedChildren="显示" />
          )}
        </Form.Item>
        <Form.Item label="备注：" className='flex'>
          {getFieldDecorator('desc', {

          })(
            <TextArea placeholder="请输入备注" style={{ width: 250, height: 80 }} />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: 350, marginLeft: 30 }}>保存</Button>
        </Form.Item>
      </Form>
    )
  }

  // 查看元素 
  lookModal(info) {
    return (
      <Form className="look-discount-detail-inner">
        <Form.Item label="优惠券名称：" className='flex'>
          <Input value={info.name} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="优惠券类型：" className='flex'>
          <Input value={info.type === 0 ? '满减券' : '折扣券'} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="面额：" className='flex'>
          <Input value={info.type === 0 ? (info.disCount / 100).toFixed(2) + '元' : info.disCount * 10 + '折'} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="使用门槛：" className='flex'>
          <Input value={info.useType === 0 ? '无门槛' : '满' + (info.useTypeVal / 100).toFixed(2) + '可使用'} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="有效期：" className='flex'>
          <Input value={info.timeType === 0 ? '领取后' + info.days + '天有效' : info.startAt + ' 至 ' + info.endAt} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="适用商户：" className='flex'>
          {
            info.platformType === 0
              ? <Input value='全平台' readOnly style={{ width: 350 }} />
              : <ul style={{ paddingLeft: 0 }} className='look-detail-inner flex' >
                {
                  info.merchantArr.map((item, index) => {
                    if (index !== info.merchantArr.length - 1) {
                      return <li key={item}>{item + '，'}</li>
                    } else {
                      return <li key={item}>{item}</li>
                    }
                  })
                }
              </ul>
          }

        </Form.Item>
        <Form.Item label="适用商品：" className='flex'>
          {
            info.useClassify === 1
              ? <Input value='全部商品' readOnly style={{ width: 350 }} />
              : <Input value={info.classifyValName} readOnly style={{ width: 350 }} />
          }

        </Form.Item>
        <Form.Item label="总发行量：" className='flex'>
          <Input value={info.total} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="每人限领：" className='flex'>
          <Input value={info.limit || 0} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="是否隐藏：" className='flex'>
          <Input value={info.hide?'隐藏':'显示'} readOnly style={{ width: 350 }} />
        </Form.Item>
        <Form.Item label="备注：" className='flex'>
          <TextArea value={info.desc} readOnly style={{ width: 350 }} />
        </Form.Item>
      </Form>
    )
  }

  // 查看优惠券详情
  lookDetail = (id) => {
    discountDetail({ id })
      .then(res => {
        const { merchant } = this.state

        let data = res.data.platformVal
        if (data && data.length) {
          data = JSON.parse(data)
          const merchantArr = []
          data.forEach(item => {
            const merchantCur = merchant.filter(child => child.id === item)[0] || ''
            if (merchantCur) {
              merchantArr.push(merchantCur.merchantName)
            }
          })
          res.data.merchantArr = merchantArr
          this.setState({
            info: res.data,
            lookModelVisible: true,
          })
        } else {
          this.setState({
            info: res.data,
            lookModelVisible: true,
          })
        }
      })
  }

  render() {
    const {
      isLoading,
      list,
      columns,
      pageData,
      lookModelVisible,
      createModelVisible,
      info,
    } = this.state
    return (
      <Layout className="discount-page">
        {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-inner'>
          <Row>
            <Col {...ColProps} xl={{ span: 10 }} md={{ span: 8 }} className="flex-h-a">
              <Button className='creat-station' type="primary" icon="plus" style={{ marginBottom: 20, width: 160 }} onClick={this.create}>添加优惠券</Button>
            </Col>
            <Col {...ColProps} xl={{ span: 10 }} md={{ span: 8 }} className="flex-h-a">
              <span >优惠券名称：</span>
              <Search style={{ width: 250 }} placeholder="优惠券名称搜索" onSearch={this.onSearch} enterButton />
            </Col>
          </Row>
          {
            !isLoading
              ? <Table
                columns={columns}
                dataSource={list}
                bordered
                rowKey="id"
                pagination={{
                  current: pageData.current,
                  total: pageData.total,
                  pageSize: pageData.pageSize,
                }}
                onChange={this.onPageChange}
              />
              : ''
          }
          <Modal
            title="创建优惠券"
            visible={createModelVisible}
            onCancel={this.handleCancel}
            width={500}
            footer={false}
          >
            {this.createModal()}
          </Modal>
          <Modal
            title="查看优惠券"
            visible={lookModelVisible}
            onCancel={this.handleCancel}
            width={600}
            footer={false}
          >
            {info && this.lookModal(info)}
          </Modal>

        </div>
      </Layout>
    )
  }
}

export default connect()(Form.create({ name: '' })(Discount))